import { render, staticRenderFns } from "./LoadingIndicator.vue?vue&type=template&id=b22e12c6&scoped=true&"
import script from "./LoadingIndicator.vue?vue&type=script&lang=ts&"
export * from "./LoadingIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingIndicator.vue?vue&type=style&index=0&id=b22e12c6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22e12c6",
  null
  
)

export default component.exports